import styled from 'styled-components';
import { ColumnFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';
import { IconWithText } from '../../../../../stories/molecules';

export const RfidMetricsContainer = styled(ColumnFlexContainer)`
  & > div {
    border-bottom: ${({ theme: { color, palette } }) =>
      `1px solid ${palette.mode === 'dark' ? color.borderGrayDark : color.borderGray}`};
  }
  & :last-child {
    border: none;
  }
`;

export const StyledIconWithText = styled(IconWithText)`
  & > div {
    color: ${({ theme: { color, palette } }) =>
      palette.mode === 'dark' ? color.secondaryDarkTextGray : color.secondaryTextGray};
  }
`;
